export const userIsFirm = (userType) =>
  ['firm', 'firm-admin'].includes(userType)
